import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const ButtonsContainer = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Card = styled.div`
  width: 100%;
`

export const CardBody = styled.div`
  padding: 24px;
  background-color: ${colors.white};
  border-radius: 4px;
`

export const IconContainer = styled.div`
  display: flex;
  margin-right: 10px;
`

export const TabTriggersOverflow = styled.div`
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`

export const TabTriggersContainer = styled.div`
  display: flex;
  overflow: hidden;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 576px) {
    position: relative;
    width: 100vw;
  }
`

export const TabTrigger = styled.p<{ active?: boolean }>`
  flex-shrink: 0;
  margin: 0 0 24px 0 !important;
  padding: 10px 24px;
  border-bottom: 2px solid
    ${({ active }) => (active ? colors.green : colors.greyStroke)};
  color: ${colors.mainText};
  font-size: 14px;
  cursor: pointer;

  span {
    margin-left: 8px;
    color: ${colors.greyTextBlackBg};
    font-size: 14px;
  }
  &:hover {
    border-color: ${({ active }) =>
      active ? colors.green : colors.greyTextBlackBg};
  }
`

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: scroll;
  -ms-overflow-style: none;
    scrollbar-width: none;

  &::-webkit-scrollbar { 
    display: none;
  }
}
`

export const RefreshBtnMobile = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: none;
  background-color: ${colors.white};
`
